// Lightweight in-memory stale-while-revalidate cache for instant section switches.
// Cleared on logout. Resets on full page reload (module-level Map).
// Capped (LRU-ish) so long sessions flipping dates never grow unbounded.
const store = new Map();
const MAX_ENTRIES = 40;

export const cacheGet = (key) => (store.has(key) ? store.get(key) : null);

export const cacheSet = (key, value) => {
  if (store.has(key)) store.delete(key); // refresh recency
  store.set(key, value);
  if (store.size > MAX_ENTRIES) {
    const oldest = store.keys().next().value;
    store.delete(oldest);
  }
};

export const cacheClear = () => { store.clear(); };
